export const mobileRegex = /^\d*$/;
